function koppaIdentityCore() {
  const version = '2026-10-20.1';
  const key = 'e8679c03351bdf21ef1914f5cf352a7b';
  const cookie = 'KOPPA_AMP_ID_V1';
  const sdkCookie = 'AMP_' + key.slice(0, 10);
  // The Amplitude Shopify app's SDK (window.amplitude) keeps its identity in
  // this cookie, and the app's checkout pixel follows it. Same name as APP in
  // the <head> script of layout/theme.liquid; update both on a reinstall.
  const appCookie = 'AMP_73170b9437';
  const shopifyCustomerId = value => value ? String(value).replace(/^gid:\/\/shopify\/Customer\//, '') : undefined;
  const ttl = 30 * 60 * 1000;
  const id = value => typeof value === 'string' && value.length >= 5 ? value : undefined;
  const user = value => typeof value === 'string' && (value.includes('@') || /^\+[0-9]{5,}$/.test(value)) ? value.trim() : undefined;
  const positive = value => Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : undefined;
  function decode(raw) {
    if (!raw || typeof raw !== 'string') return null;
    const candidates = [raw];
    try { candidates.push(decodeURIComponent(raw)); } catch (_) {}
    for (const candidate of [...candidates]) {
      try {
        const decoded = atob(candidate.replace(/-/g, '+').replace(/_/g, '/'));
        candidates.push(decoded);
        try { candidates.push(decodeURIComponent(decoded)); } catch (_) {}
      } catch (_) {}
    }
    for (const candidate of candidates) {
      try {
        const parsed = JSON.parse(candidate);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
      } catch (_) {}
    }
    return null;
  }
  function state(value) {
    if (!value || !id(value.deviceId)) return null;
    return {deviceId: value.deviceId, userId: user(value.userId), sessionId: positive(value.sessionId),
      lastEventTime: positive(value.lastEventTime), customerId: shopifyCustomerId(value.customerId),
      clientId: id(value.clientId), source: value.source || 'sdk_cookie', optOut: value.optOut === true};
  }
  function session(value, time) {
    const next = {...value};
    const last = next.lastEventTime || next.sessionId;
    if (!next.sessionId || !last || time - last > ttl) next.sessionId = time;
    next.lastEventTime = Math.max(time, last || 0);
    return next;
  }
  function cookieString(value) {
    return cookie + '=' + encodeURIComponent(JSON.stringify(value)) + '; Path=/; Max-Age=31536000; SameSite=Lax; Secure';
  }
  // The device id the app's SDK is using, if it has one yet.
  function appDevice(raw) { return id(decode(raw)?.deviceId); }
  // Hands deviceId to the app's SDK before it starts: it reads its device id
  // from this cookie and has no deviceId option of its own. Written in the
  // app SDK's own encoding and on the domain it uses, so it is the same cookie
  // and not a second one beside it. Empty once the app has an id.
  function appCookieString(raw, deviceId, hostname) {
    if (appDevice(raw) || !id(deviceId)) return '';
    const value = btoa(encodeURIComponent(JSON.stringify({...decode(raw), deviceId})));
    const domain = /(^|\.)koppabeauty\.com$/.test(hostname || '') ? '; Domain=.koppabeauty.com' : '';
    return appCookie + '=' + value + '; Path=/; Max-Age=31536000; SameSite=Lax; Secure' + domain;
  }
  return {version, key, cookie, sdkCookie, appCookie, ttl, id, user, positive, decode, state, session, cookieString,
    appDevice, appCookieString, shopifyCustomerId};
}

(function () {
  'use strict';
  const core = koppaIdentityCore();
  const ctx = window.CupraAnalytics || {};
  // Team, AI-agent and automated traffic never loads Amplitude (analytics or
  // session replay). layout/theme.liquid reaches that verdict in the <head>,
  // before the Amplitude Shopify app's SDK starts, and publishes it as
  // window.KoppaInternal; the reasons are listed there. The fallback below
  // covers a page rendered without that script, using the country tests only.
  let internal = window.KoppaInternal;
  if (!internal) {
    let timeZone = '';
    try { timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (_) {}
    const team = ['ID'].includes(ctx.region) ||
      ['Asia/Jakarta', 'Asia/Pontianak', 'Asia/Makassar', 'Asia/Jayapura'].includes(timeZone);
    internal = {internal: team, reason: team ? 'team_country' : ''};
  }
  if (internal.internal) {
    window.KoppaAnalyticsIdentity = {allowed: () => false, consentState: () => false, sync() {}, version: core.version, excluded: internal.reason};
    return;
  }
  const pageViewId = crypto.randomUUID();
  // Analytics and session replay are separate imports (PageSpeed 2026-09-30).
  // @amplitude/unified pulled rrweb, Experiment and Engagement in with the
  // analytics SDK on every page view: ~1.7 s of main-thread work on mobile and
  // the three longest tasks in the trace. Analytics now starts once the page has
  // loaded (or on the first interaction, if that comes sooner); replay starts on
  // the first interaction, since a visit with none has nothing to replay.
  // Experiment was never read and Engagement was skipped, so both are dropped.
  const ANALYTICS_URL = 'https://cdn.jsdelivr.net/npm/@amplitude/analytics-browser@2.45.10/+esm';
  const REPLAY_URL = 'https://cdn.jsdelivr.net/npm/@amplitude/plugin-session-replay-browser@1.35.1/+esm';
  const INTERACTIONS = ['pointerdown', 'keydown', 'touchstart', 'scroll', 'wheel', 'mousemove'];
  let current, sdk, starting, replay, replayStarting, interacted = false;
  function readCookie(name) {
    const prefix = name + '=';
    return document.cookie.split(';').map(v => v.trim()).find(v => v.startsWith(prefix))?.slice(prefix.length) || '';
  }
  function consentState() {
    // Decision 2026-09-27: Amplitude runs unless the visitor explicitly declined
    // analytics; a banner never answered (most visitors) no longer blocks it.
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return true;
    try { return privacy.currentVisitorConsent().analytics !== 'no'; } catch (_) { return true; }
  }
  function allowed() { return consentState() === true; }
  function readState() {
    const sdkState = core.state(core.decode(readCookie(core.sdkCookie)));
    const bridge = core.state(core.decode(readCookie(core.cookie)));
    let local;
    try { local = core.state(core.decode(localStorage.getItem(core.cookie))); } catch (_) {}
    return sdkState || bridge || local;
  }
  function persist(value) {
    if (!allowed()) return;
    current = {...value, version: core.version};
    document.cookie = core.cookieString(current);
    try { localStorage.setItem(core.cookie, JSON.stringify(current)); } catch (_) {}
  }
  function sync() {
    if (!allowed() || !sdk || sdk.getOptOut()) return;
    persist({...current, deviceId: sdk.getDeviceId(), userId: core.user(sdk.getUserId()),
      sessionId: sdk.getSessionId(), lastEventTime: Date.now()});
    try { window.Shopify.analytics.publish('koppa_identity_ready', {
      device_id: current.deviceId, session_id: current.sessionId, user_id: current.userId,
      shopify_customer_id: current.customerId, identity_version: core.version,
      attribution: window.KoppaAttribution ? window.KoppaAttribution.state() : undefined,
      quiz_context: window.KoppaDetailedTracking ? window.KoppaDetailedTracking.context() : undefined
    }); } catch (_) {}
  }
  async function start() {
    if (!allowed()) return;
    if (sdk) {
      sdk.setOptOut(false);
      current = readState() || core.session({deviceId: sdk.getDeviceId()}, Date.now());
      window.koppaAmplitude = sdk;
      sync();
      window.dispatchEvent(new CustomEvent('amplitude:ready'));
      return;
    }
    if (starting) return starting;
    let existing = readState();
    if (existing?.optOut) return;
    const identified = core.user(ctx.customerEmail) || core.user(ctx.customerPhone);
    if (existing?.userId && identified && existing.userId !== identified) existing = null;
    // One device id for both SDKs. The Amplitude app's storefront SDK and its
    // checkout pixel share one; this SDK and the Koppa checkout pixel (Order
    // Completed) share another. Until 2026-10-20 the two were minted
    // separately, so a shopper's browsing and checkout landed on two Amplitude
    // users unless an email joined them: 4 of 18 orders in the 30 days to
    // 2026-10-20. The app's id wins; if it has none yet, it is given ours.
    let appDevice = core.appDevice(readCookie(core.appCookie));
    try { appDevice = appDevice || core.id(window.amplitude?.getDeviceId?.()); } catch (_) {}
    if (appDevice && existing?.deviceId !== appDevice) existing = {...existing, deviceId: appDevice, source: 'shopify_app'};
    current = core.session(existing || {deviceId: crypto.randomUUID(), source: 'storefront_created'}, Date.now());
    current.userId = identified || current.userId;
    current.customerId = ctx.customerId ? String(ctx.customerId) : current.customerId;
    persist(current);
    if (!appDevice) {
      const seed = core.appCookieString(readCookie(core.appCookie), current.deviceId, location.hostname);
      if (seed) document.cookie = seed;
    }
    starting = import(ANALYTICS_URL).then(async lib => {
      if (!allowed()) return;
      // A fresh instance rather than the module's default export, so the object
      // is extensible (sessionReplay() below) and never collides with the
      // Shopify app's window.amplitude.
      const amplitude = lib.createInstance();
      amplitude.add({name: 'koppa-identity-metadata', type: 'enrichment', setup: async () => {}, execute: async event => {
        if (!allowed()) return null;
        persist({...current, deviceId: event.device_id || amplitude.getDeviceId(),
          userId: core.user(event.user_id), sessionId: event.session_id || amplitude.getSessionId(),
          lastEventTime: event.time || Date.now()});
        const quiz = window.KoppaDetailedTracking ? window.KoppaDetailedTracking.context() : {};
        const shared = Object.fromEntries(Object.entries(quiz).filter(([key]) => key.startsWith('koppa_')));
        event.event_properties = {...(window.KoppaAttribution ? window.KoppaAttribution.context() : {}), ...quiz,
          page_view_id:pageViewId, page_path:ctx.pagePath || location.pathname,
          page_type:ctx.pageType, language:ctx.language, currency:ctx.currency, region:ctx.region,
          ...event.event_properties, identity_version: core.version,
          tracking_source: 'koppa_storefront', identity_source: current.source,
          shopify_customer_id: current.customerId};
        if (current.customerId) event.user_properties = {...event.user_properties, shopify_customer_id: current.customerId};
        if (Object.keys(shared).length) event.user_properties = {...event.user_properties, ...shared};
        return event;
      }});
      await amplitude.init(core.key, {serverZone: 'US',
        autocapture: true, deviceId: current.deviceId, userId: current.userId,
        sessionId: current.sessionId, cookieOptions: {sameSite: 'Lax', secure: true},
        identityStorage: 'cookie'
      }).promise;
      // koppa-consent.js shuts replay down through this on an explicit opt-out.
      amplitude.sessionReplay = () => replay;
      sdk = amplitude;
      if (!allowed()) { sdk.setOptOut(true); return; }
      window.koppaAmplitude = sdk;
      sync();
      window.dispatchEvent(new CustomEvent('amplitude:ready'));
      if (interacted) startReplay();
    }).catch(() => { console.warn('[Koppa analytics] SDK initialization failed'); }).finally(() => { starting = null; });
    return starting;
  }
  // Replay only on the published theme. A preview theme or the theme editor
  // is the team looking at its own work: analytics still run there (tracking
  // is verified on previews), but a recording of it is wasted replay quota.
  function liveTheme() {
    const shop = window.Shopify || {};
    if (shop.designMode) return false;
    return !shop.theme || !shop.theme.role || shop.theme.role === 'main';
  }
  function startReplay() {
    if (replay || replayStarting || !sdk || !allowed() || sdk.getOptOut() || !liveTheme()) return;
    replayStarting = import(REPLAY_URL).then(async lib => {
      if (!sdk || !allowed() || sdk.getOptOut()) return;
      const plugin = lib.sessionReplayPlugin({serverZone: 'US', sampleRate: 1,
        privacyConfig: {defaultMaskLevel: 'conservative'}});
      await sdk.add(plugin).promise;
      replay = plugin.sessionReplay;
    }).catch(() => { console.warn('[Koppa analytics] Session replay failed to start'); })
      .finally(() => { replayStarting = null; });
  }
  function firstInteraction() {
    if (interacted) return;
    interacted = true;
    INTERACTIONS.forEach(type => window.removeEventListener(type, firstInteraction, true));
    if (sdk) startReplay(); else consentChanged();
  }
  function consentChanged() {
    if (allowed()) start();
    else {
      if (sdk) sdk.setOptOut(true);
      current = null;
      document.cookie = core.cookie + '=; Path=/; Max-Age=0; SameSite=Lax; Secure';
      try { localStorage.removeItem(core.cookie); } catch (_) {}
      window.dispatchEvent(new CustomEvent('koppa:analytics-denied'));
    }
  }
  window.KoppaAnalyticsIdentity = {allowed, consentState, sync, version: core.version};
  document.addEventListener('visitorConsentCollected', consentChanged);
  document.addEventListener('click', event => {
    if (event.target.closest?.('a[href*="/account/logout"]')) {
      if (sdk) sdk.reset();
      current = undefined;
      document.cookie = core.cookie + '=; Path=/; Max-Age=0; SameSite=Lax; Secure';
      try { localStorage.removeItem(core.cookie); } catch (_) {}
    } else if (event.target.closest?.('[name="checkout"], a[href*="/checkout"]')) sync();
  }, true);
  window.addEventListener('pagehide', sync);
  INTERACTIONS.forEach(type => window.addEventListener(type, firstInteraction, {capture: true, passive: true}));
  function boot() {
    if (window.Shopify?.customerPrivacy) consentChanged();
    else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => {
      // Start either way: without the privacy API, consentState() treats the visitor as not declined.
      consentChanged();
    });
    else consentChanged();
  }
  // Off the critical path: after the load event, in the first idle slot.
  const idle = fn => ('requestIdleCallback' in window ? requestIdleCallback(fn, {timeout: 3000}) : setTimeout(fn, 1));
  if (document.readyState === 'complete') idle(boot);
  else window.addEventListener('load', () => idle(boot), {once: true});
})();
